import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const RegisterPage = lazy(() => import('../pages/register/page'));
const UserDashboardPage = lazy(() => import('../pages/user-dashboard/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin-dashboard/page'));
const EmailTestPage = lazy(() => import('../pages/email-test/page'));

// ... existing code ...

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/faq', element: <FAQPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/user/dashboard', element: <UserDashboardPage /> },
  { path: '/admin/dashboard', element: <AdminDashboardPage /> },
  { path: '/email-test', element: <EmailTestPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
